import { connect } from 'react-redux';
import {
  isLoading,
  getCurrentPatient,
  isDataForPatientById,
} from 'store/selectors/patientEngagement';
import { patientEngagementInitStatusesPage } from 'store/actionCreators/patientEngagement';

import PatientEngagementWrapper from 'components/PatientEngagement/PatientEngagementWrapper';

const mapStateToProps = (
  state,
  {
    match: {
      params: { id },
    },
  },
) => ({
  patientId: id,
  loadedPatientId: getCurrentPatient(state),
  loading: isLoading(state),
  isData: isDataForPatientById(id)(state),
});

const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { id },
    },
  },
) => ({
  getData: () => dispatch(patientEngagementInitStatusesPage({ patientId: id })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PatientEngagementWrapper);
